import './Pagination.scss'

export default function Pagination({ page, totalItems, pageSize, onPageChange }) {
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize))
  const canPrev = page > 1
  const canNext = page < totalPages

  const getVisiblePages = () => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1)
    }
    const pages = []
    if (page <= 4) {
      for (let i = 1; i <= 5; i++) pages.push(i)
      pages.push('ellipsis')
      pages.push(totalPages)
    } else if (page >= totalPages - 3) {
      pages.push(1)
      pages.push('ellipsis')
      for (let i = totalPages - 4; i <= totalPages; i++) pages.push(i)
    } else {
      pages.push(1)
      pages.push('ellipsis')
      for (let i = page - 1; i <= page + 1; i++) pages.push(i)
      pages.push('ellipsis')
      pages.push(totalPages)
    }
    return pages
  }

  const visible = getVisiblePages()

  return (
    <nav className="shop-pagination" aria-label="Paginare produse">
      <div className="shop-pagination-inner">
        <button
          type="button"
          className="shop-pagination-btn shop-pagination-prev"
          disabled={!canPrev}
          onClick={() => onPageChange(page - 1)}
          aria-label="Pagina anterioară"
        >
          ←
        </button>
        <ul className="shop-pagination-list">
          {visible.map((p, i) =>
            p === 'ellipsis' ? (
              <li key={`ellipsis-${i}`} className="shop-pagination-ellipsis">
                …
              </li>
            ) : (
              <li key={p}>
                <button
                  type="button"
                  className={`shop-pagination-btn shop-pagination-num ${p === page ? 'active' : ''}`}
                  onClick={() => onPageChange(p)}
                  aria-label={`Pagina ${p}`}
                  aria-current={p === page ? 'page' : undefined}
                >
                  {p}
                </button>
              </li>
            )
          )}
        </ul>
        <button
          type="button"
          className="shop-pagination-btn shop-pagination-next"
          disabled={!canNext}
          onClick={() => onPageChange(page + 1)}
          aria-label="Pagina următoare"
        >
          →
        </button>
      </div>
    </nav>
  )
}
